module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-BookItalic-WebS-df6040127eb779b0ee6d61235606b742.woff2";